/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { currentUserIsPhpAdmin } from "reduxSlices/sessionSlice"
import { categoryShape } from "utils/propTypeShapes"
import { FormsyTextInput } from "shared/inputs"

const CategoryName = ({ category, className = "" }) => {
  const { id } = category

  const userMayEditCategoryName = useSelector(currentUserIsPhpAdmin)

  const inputId = `category-${id}-name-input`

  return (
    <div className={className}>
      {
        userMayEditCategoryName
          ? (
            <>
              <label htmlFor={inputId} className="field-name">Name</label>
              <FormsyTextInput
                uuid={inputId}
                className="bordered-base-input text-sm"
                name="name"
                placeholder="Name"
                value={category.name}
                required
                validations={{ isNotBlankString: true }}
                validationErrors={{ isDefaultRequiredValue: "required" }}
              />
            </>
          )
          : (
            <>
              <span className="field-name">Name</span>
              <p className="text-sm">{category.name}</p>
            </>
          )
      }
    </div>
  )
}

CategoryName.propTypes = {
  category: categoryShape.isRequired,
  className: types.string,
}

export default CategoryName
